import React from 'react';
import { Flex } from '@chakra-ui/react';
import { LocationHeader } from '../components/organisms/Location/LocationHeader';
import { LocationBody } from '../components/organisms/Location/LocationBody';

export const Location: React.FC = () => {
  return (
    <Flex direction='column' h='100vh'>
      <LocationHeader />
      <LocationBody />
    </Flex>
  );
};
